module.exports = __webpack_public_path__ + "static/media/info.475743e4.svg";